import React from 'react';
import { useTranslation } from 'react-i18next';

import RadioButton from 'src/common/refactoredComponents/RadioButton/RadioButton';
import { MainContainerItems, RadioRowDiv, Title } from './Pediatric.styled';
import { useDispatch } from 'react-redux';
import {BASE_TEXT_PX, FONT_FAMILY_REGULAR } from '../../../styles/fonts/MCFontConstants';

const Pediatric = ({
    isDisabledPediatric,
    setPediatricCheck,
    isPediatricSurgery,
    isFromSurgery,
    isFromProcedure,
    procedureText,
    pediatricMandatoryRule,
    isFromEquity,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    return (
        <>
            <MainContainerItems
                setMarginBottom={true}
                isFromProcedure={isFromProcedure || isFromEquity}
                isFromEquity={isFromEquity}
                width={isFromProcedure ? '100%' : isFromEquity ? '100%' : '47%'}
                procedureText={procedureText}
                isFromSurgery={isFromSurgery}
            >
                <Title
                    showAstrisk={pediatricMandatoryRule}
                    isFromProcedureScreen={isFromProcedure || isFromEquity}
                >
                    {isFromProcedure || isFromEquity
                        ? t('common.pediatricProcedureUsage')
                        : t('common.pediatricProcedure')}
                </Title>
                <RadioRowDiv
                    marginBottom={
                        isFromProcedure || isFromEquity ? '0px' : '15px'
                    }
                    width={true}
                    isFromProcedure={isFromProcedure || isFromEquity}
                >
                    <RadioButton
                        id="pediatric-radioButtonYes"
                        isChecked={isPediatricSurgery === true}
                        label={t(
                            'reportUsage.record.reportPayment.ReportPayment.yes'
                        )}
                        handleChange={() => {
                            try {
                            dispatch(setPediatricCheck(true));
                             } catch (error) {
                                logErrorToConsole(error);
                             }
                        }}
                        fontFamilyStyle={FONT_FAMILY_REGULAR}
                        fontSize={BASE_TEXT_PX}
                        paddingRight={'35px'}
                        iPadPaddingRight={'5px'}
                        disabled={isDisabledPediatric}
                        width={'14px'}
                    />
                    <RadioButton
                        id="pediatric-radioButtonNo"
                        isChecked={isPediatricSurgery === false}
                        label={t('equity.surgery.notifications.no')}
                        handleChange={() => {
                            try {
                            dispatch(setPediatricCheck(false));
                             } catch (error) {
                                 logErrorToConsole(error);
                            }
                        }}
                        fontFamilyStyle={FONT_FAMILY_REGULAR}
                        fontSize={BASE_TEXT_PX}
                        style={{ paddingLeft: '28px' }}
                        disabled={isDisabledPediatric}
                        width={'14px'}
                    />
                </RadioRowDiv>
            </MainContainerItems>
        </>
    );
};

export default Pediatric;
